import { Container, Box, Typography } from "@mui/material";

import LendiaIcon from "@assets/lendia_full.svg";

export const BajoConstruccion = () => {
  return (
    <Container maxWidth="sm">
      <Box textAlign="center" mt={10}>
        <Typography variant="h3" component="h1" gutterBottom>
          -- Bajo construcción --
        </Typography>
        <Box mt={5}>
          <img src={LendiaIcon} alt="Lendia Logo" style={{ width: "200px", height: "auto" }} />
        </Box>
      </Box>
    </Container>
  );
};
